import { Box, styled } from '@mui/material';
import { FC, PropsWithChildren, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ConvergeTooltip, FormTextField } from '../../../../presentation';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import './rater.quote-name.scss';

const StyledBox = styled(Box)(() => ({
  display: 'flex',
  columnGap: '5px',
  justifyContent: 'center',
  alignItems: 'center',
}));

interface IRaterQuoteNameProps {
  onChange?: (quoteName: string) => Promise<void> | void;
  quoteName: string;
  disabled?: boolean;
  component: FC<Record<string, unknown> & Required<PropsWithChildren>>;
}

interface IFormData {
  quoteName: string;
}

export const RaterQuoteName = ({
  onChange,
  quoteName,
  disabled = false,
  component: Component,
}: IRaterQuoteNameProps) => {
  const [edit, setEdit] = useState(false);

  const handleClick = () => {
    setEdit(true);
  };
  const handleClose = () => {
    setEdit(false);
  };
  const onSubmit = async (data: IFormData) => {
    if (onChange) {
      await onChange(data.quoteName);
    }
    handleClose();
  };

  const methods = useForm<IFormData>({
    resolver: yupResolver(
      Yup.object().shape({
        quoteName: Yup.string()
          .required('Quote name cannot be empty')
          .trim()
          .min(1, 'Quote name cannot be empty'),
      })
    ),
    defaultValues: { quoteName },
    shouldUseNativeValidation: false,
  });

  return (
    <StyledBox>
      {edit && !disabled ? (
        <FormProvider {...methods}>
          <form
            onSubmit={methods.handleSubmit(onSubmit)}
            className="quote-name-form"
          >
            <FormTextField
              id="outlined-error-helper-text"
              label=""
              name="quoteName"
              required
              className="form-field"
              hiddenLabel
              autoFocus
              disabled={methods.formState.isSubmitting}
              onBlur={methods.handleSubmit(onSubmit)}
            />
          </form>
        </FormProvider>
      ) : (
        <>
          {disabled ? (
            <Component>{quoteName}</Component>
          ) : (
            <ConvergeTooltip title="Edit quote name">
              <Box onClick={handleClick}>
                <Component>{quoteName}</Component>
              </Box>
            </ConvergeTooltip>
          )}
        </>
      )}
    </StyledBox>
  );
};
